import React from 'react';
import Helpers from 'utils/helpers';

export default function PlaintextInput(props) {
  const getClass = () => {
    let classNames = ['form-control-plaintext', 'plaintext', props.className];
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      {props.value || props.children}
    </div>
  );
}